import '../../utils/polyfills';

// import blocks and sections
// in fact, there are only styles must be imported
// React and other fancy stuff must be cut off

import '../../components/layout/index';
import '../../components/clients/index';
import '../../components/cta-block/index';
import '../../components/gallery/index';
import '../../components/hero/index';
import '../../components/map/index';
import '../../components/projects/index';
import '../../components/sections/base-section';
import '../../components/slider/index';
import '../../components/tiles/index';
import '../../components/analytics/index';

// import and apply behaviors to the components



// WEBPACK FOOTER //
// ./src/entries/site/app.js